import { useSyncExternalStore } from "react";

// The browser's word on the network. `navigator.onLine` false is reliable (no
// network at all); true only means a connection exists, so a call can still
// fail as unreachable.

export const isOnline = () => navigator.onLine;

function subscribe(onChange: () => void) {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

/** Re-renders when the browser goes on or offline. */
export const useOnline = () => useSyncExternalStore(subscribe, isOnline, () => true);
